module.exports = __webpack_public_path__ + "img/pass_card_1.b6dd8402.png";